import { createActions } from 'redux-actions';
import { apiActions as commonApiActions, apiResourceActionCreator, endpointQuery } from '../../common';

export const API_ENDPOINT = 'publisher/published-event';

const actions = createActions({
  PUBLISHER_PORTAL: {
    PUBLISHED_EVENT: {
      API: {
        GET: apiResourceActionCreator('eventsResult'),
        LOAD_MORE: apiResourceActionCreator('eventsResult'),
        ADD_PUBLISHED_EVENT: apiResourceActionCreator('published-event'),
        UPDATE_PUBLISHED_EVENT: apiResourceActionCreator('published-event'),
        GET_PUBLISHED_EVENT_BY_ID: apiResourceActionCreator('published-event'),
        DELETE_EVENT: apiResourceActionCreator('deletedId')
      },
      GET: (skip, query) => ({ skip, query }),
      LOAD_MORE: (skip, query) => ({ skip, query }),
      SAVE_PUBLISHED_EVENT: (publishedEvent, nextRoute) => ({ publishedEvent, nextRoute }),
      UPDATE_PUBLISHED_EVENT: (publishedEvent, nextRoute, publishedEventId) => ({ publishedEvent, nextRoute, publishedEventId }),
      GET_PUBLISHED_EVENT_BY_ID: (publishedEventId) => ({ publishedEventId }),
      DELETE_EVENT: (eventId, eventQuery, nextRoute) => ({ eventId, eventQuery, nextRoute })
    }
  }
});

export const apiActions = {
  publisherPortal: {
    publishedEvent: {
      get: (authToken, skip, query) => commonApiActions.authenticated.get(`${API_ENDPOINT}${endpointQuery({ ...(query || {}), skip })}`, authToken, actions.publisherPortal.publishedEvent.api.get),
      loadMore: (authToken, skip, query) => commonApiActions.authenticated.get(`${API_ENDPOINT}${endpointQuery({ ...(query || {}), skip })}`, authToken, actions.publisherPortal.publishedEvent.api.loadMore),
      addPublishedEvent: (authToken, formData) => commonApiActions.authenticated.postFormData(`${API_ENDPOINT}`, authToken, formData, actions.publisherPortal.publishedEvent.api.addPublishedEvent),
      updatePublishedEvent: (authToken, formData, publishedEventId) => commonApiActions.authenticated.postFormData(`${API_ENDPOINT}/${publishedEventId}`, authToken, formData, actions.publisherPortal.publishedEvent.api.updatePublishedEvent),
      getPublishedEventById: (authToken, publishedEventId) => commonApiActions.authenticated.get(`${API_ENDPOINT}/${publishedEventId}`, authToken, actions.publisherPortal.publishedEvent.api.getPublishedEventById),
      deleteEvent: (authToken, eventId) => commonApiActions.authenticated.delete(`${API_ENDPOINT}/${eventId}`, authToken, actions.publisherPortal.publishedEvent.api.deleteEvent)
    }
  }
};

export default actions;



// WEBPACK FOOTER //
// ./src/state/modules/publisher-portal/published-event/actions.js